import React from "react";

import { func, string, bool, object } from "prop-types";

import { TextAreaGroup } from "../../../../common/index";

const Seeking = ({
  positionSeeking,
  onChangeHandler,
  isValid,
  validation = undefined,
}) => (
  <div className="my-2">
    <h3>Type of work sought*</h3>
    <TextAreaGroup
      value={positionSeeking}
      onChange={(e) => {
        onChangeHandler("positionSeeking", e.target.value);
      }}
      classes="register_field col-md-7"
      placeholder="e.g. Driver"
      validationMessages={isValid ? [] : validation.positionSeeking}
      validationMessageIsRed
      showInvalid
    />
    <div className="fontSize-12 text-lightGrey mb-hf">
      <p className="mb-0 mt-1">
        Please list at least 5 job types/roles you are seeking, e.g.:
      </p>
      <ul className="pl-1">
        <li>Warehouse operative, picker, packer, cleaner, general assistant</li>
        <li>
          Administrator, office worker, data entry, receptionist, accounts
          assistant
        </li>
        <li>
          Catering assistant, waiting staff, bar staff, housekeeping, data entry
        </li>
      </ul>
    </div>
  </div>
);

Seeking.propTypes = {
  isValid: bool.isRequired,
  validation: object,
  positionSeeking: string.isRequired,
  onChangeHandler: func.isRequired,
};

export default Seeking;
